import * as React from 'react'
import { SVGProps } from 'react'
const SvgPlayFull = (props: SVGProps<SVGSVGElement>) => (
  <svg height={357} viewBox="0 0 357 357" width={357} {...props}>
    <path d="M38.25 0v357l280.5-178.5z" />
  </svg>
)
export default SvgPlayFull
